export interface BankEntry {
  code: string;
  name: string;
  fullName: string;
}

export const BRAZILIAN_BANKS: BankEntry[] = [
  { code: '001', name: 'Banco do Brasil', fullName: 'Banco do Brasil S.A.' },
  { code: '003', name: 'BASA', fullName: 'Banco da Amazônia S.A.' },
  { code: '004', name: 'BNB', fullName: 'Banco do Nordeste do Brasil S.A.' },
  { code: '021', name: 'Banestes', fullName: 'Banco do Estado do Espírito Santo S.A.' },
  { code: '033', name: 'Santander', fullName: 'Banco Santander (Brasil) S.A.' },
  { code: '037', name: 'Banpará', fullName: 'Banco do Estado do Pará S.A.' },
  { code: '041', name: 'Banrisul', fullName: 'Banco do Estado do Rio Grande do Sul S.A.' },
  { code: '047', name: 'Banese', fullName: 'Banco do Estado de Sergipe S.A.' },
  { code: '069', name: 'Crefisa', fullName: 'Crefisa S.A.' },
  { code: '070', name: 'BRB', fullName: 'Banco de Brasília S.A.' },
  { code: '077', name: 'Banco Inter', fullName: 'Banco Inter S.A.' },
  { code: '082', name: 'Banco Topázio', fullName: 'Banco Topázio S.A.' },
  { code: '085', name: 'Ailos', fullName: 'Cooperativa Central de Crédito - Ailos' },
  { code: '097', name: 'Credisis', fullName: 'Central de Cooperativas de Crédito do Sist. Ailos' },
  { code: '099', name: 'Uniprime', fullName: 'Uniprime Central' },
  { code: '104', name: 'Caixa Econômica', fullName: 'Caixa Econômica Federal' },
  { code: '133', name: 'Cresol', fullName: 'Cresol Confederação' },
  { code: '136', name: 'Unicred', fullName: 'Unicred Cooperativa' },
  { code: '197', name: 'Stone', fullName: 'Stone Pagamentos S.A.' },
  { code: '208', name: 'BTG Pactual', fullName: 'Banco BTG Pactual S.A.' },
  { code: '212', name: 'Banco Original', fullName: 'Banco Original S.A.' },
  { code: '218', name: 'BS2', fullName: 'Banco BS2 S.A.' },
  { code: '237', name: 'Bradesco', fullName: 'Banco Bradesco S.A.' },
  { code: '243', name: 'Banco Master', fullName: 'Banco Master S.A.' },
  { code: '246', name: 'ABC Brasil', fullName: 'Banco ABC Brasil S.A.' },
  { code: '260', name: 'Nubank', fullName: 'Nu Pagamentos S.A.' },
  { code: '290', name: 'PagBank', fullName: 'PagBank (PagSeguro)' },
  { code: '318', name: 'BMG', fullName: 'Banco BMG S.A.' },
  { code: '323', name: 'MercadoPago', fullName: 'Mercado Pago' },
  { code: '336', name: 'C6 Bank', fullName: 'C6 Bank S.A.' },
  { code: '341', name: 'Itaú Unibanco', fullName: 'Itaú Unibanco S.A.' },
  { code: '348', name: 'XP Investimentos', fullName: 'XP Investimentos Corretora' },
  { code: '380', name: 'PicPay', fullName: 'PicPay Serviços S.A.' },
  { code: '389', name: 'Mercantil do Brasil', fullName: 'Banco Mercantil do Brasil S.A.' },
  { code: '399', name: 'Kirton Bank', fullName: 'Kirton Bank S.A.' },
  { code: '403', name: 'Cora', fullName: 'Cora Sociedade de Crédito' },
  { code: '413', name: 'BV', fullName: 'Banco BV S.A.' },
  { code: '422', name: 'Safra', fullName: 'Banco Safra S.A.' },
  { code: '461', name: 'Asaas', fullName: 'Asaas Gestão Financeira' },
  { code: '473', name: 'Caixa Geral', fullName: 'Banco Caixa Geral S.A.' },
  { code: '505', name: 'Credit Suisse', fullName: 'Credit Suisse (Brasil) S.A.' },
  { code: '633', name: 'Rendimento', fullName: 'Banco Rendimento S.A.' },
  { code: '637', name: 'Sofisa', fullName: 'Banco Sofisa S.A.' },
  { code: '654', name: 'BPP', fullName: 'Banco PAN S.A.' },
  { code: '655', name: 'Votorantim', fullName: 'Banco Votorantim S.A.' },
  { code: '707', name: 'Daycoval', fullName: 'Banco Daycoval S.A.' },
  { code: '739', name: 'Cetelem', fullName: 'Banco Cetelem S.A.' },
  { code: '745', name: 'Citibank', fullName: 'Citibank N.A.' },
  { code: '748', name: 'Sicredi', fullName: 'Banco Cooperativo Sicredi S.A.' },
  { code: '752', name: 'BNP Paribas', fullName: 'Banco BNP Paribas Brasil S.A.' },
  { code: '755', name: 'Bank of America', fullName: 'Bank of America Merrill Lynch' },
  { code: '756', name: 'Sicoob', fullName: 'Banco Cooperativo do Brasil S.A. - Sicoob' },
  { code: '077', name: 'Neon', fullName: 'Banco Neon S.A.' },
  { code: 'n/a', name: 'Wise', fullName: 'Wise (TransferWise)' },
  { code: 'n/a', name: 'Revolut', fullName: 'Revolut Ltd.' },
  { code: 'n/a', name: 'PayPal', fullName: 'PayPal Brasil' },
  { code: 'n/a', name: 'Binance', fullName: 'Binance Exchange' },
  { code: 'n/a', name: 'Coinbase', fullName: 'Coinbase Inc.' },
  { code: 'n/a', name: 'Foxbit', fullName: 'Foxbit Corretora' },
  { code: 'n/a', name: 'Mercado Bitcoin', fullName: 'Mercado Bitcoin Corretora' },
  { code: 'n/a', name: 'Outro', fullName: 'Outro / Manual' },
];
